import {useNavigate} from 'react-router-dom';
import {
    FlexiCancelButton
} from "@flexinet/ui-components";
import {AiOutlineEdit} from "react-icons/ai";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {EditButton} from "../buttons/EditButton.tsx";
import {DownloadButton} from "../buttons/DownloadButton.tsx";
import {RetakeButton} from "../buttons/RetakeButton.tsx";

export const useEditPageTools = () => {

    const navigate = useNavigate();

    const {allowedActions} = useVerifiedPermissions()

    const tools = [];

    if (allowedActions.includes('UpdateApplicationScreenshot')) {
        tools.push(<EditButton leftSection={<AiOutlineEdit/>} variant={'filled'}
                               key={'edit'}>Edit</EditButton>);
    }

    tools.push(<RetakeButton key={'retake'}/>);

    tools.push(<DownloadButton key={'download'}/>);

    tools.push(<FlexiCancelButton key={'close'}
                                  onClick={() => navigate(`/application-screenshots`)}/>);


    return {
        tools,
    };

};
